import React from "react";
import ReactDom from "react-dom";
import RecentlyViewedList from "./RecentlyViewedList.jsx";

export function initRecentlyViewed() {
  const div = document.querySelector(".global-header__desktop .recently-viewed");
  if (div) {
    ReactDom.render(<RecentlyViewedList />, div);
  }
}
